module.exports = __webpack_public_path__ + "static/media/thumb_SEXP4403_1024.6daa82e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_SEXP4403_1024.jpg
// module id = 137
// module chunks = 0